<script>
import * as LucideIcons from 'lucide';

export default {
    name: 'LucideIcon',
    functional: true,
    props: {
        name: { type: String, required: true },
        size: { type: [Number, String], default: 24 },
        strokeWidth: { type: [Number, String], default: 2 },
        fill: { type: String, default: 'none' },
    },
    render(h, ctx) {
        const iconNode = LucideIcons[ctx.props.name];
        if (!iconNode || !Array.isArray(iconNode)) {
            return null;
        }

        const classStr = [ctx.data.class, ctx.data.staticClass].filter(Boolean).join(' ');
        const usesFillClass = /\bfill-(?!none\b)/.test(classStr);
        const svgFill = usesFillClass ? 'currentColor' : ctx.props.fill;

        const children = iconNode.map(([tag, attrs]) => {
            return h(tag, {
                attrs: {
                    ...attrs,
                    fill: usesFillClass ? 'currentColor' : (attrs.fill || ctx.props.fill),
                },
            });
        });

        return h('svg', {
            attrs: {
                xmlns: 'http://www.w3.org/2000/svg',
                width: ctx.props.size,
                height: ctx.props.size,
                viewBox: '0 0 24 24',
                fill: svgFill,
                stroke: 'currentColor',
                'stroke-width': ctx.props.strokeWidth,
                'stroke-linecap': 'round',
                'stroke-linejoin': 'round',
            },
            class: ctx.data.class,
            staticClass: ctx.data.staticClass,
            style: ctx.data.style,
        }, children);
    },
};
</script>
